import React, { Suspense } from 'react';
import { SkeletonText } from '@cardboard-ui/react';
import { graphql, useFragment } from 'utils/graphClient';
import { ItemMenu_node$key } from './__generated__/ItemMenu_node.graphql';
import { ErrorBoundary } from 'utils/errors';
import { ItemMenuError } from './components/ItemMenuError';
import { ItemMenu as ItemMenuComponent, ItemMenuProps } from './ItemMenu';

const nodeFragment = graphql`
  fragment ItemMenu_node on Node {
    __typename
    id
    ...TagButton_node
    ...TagsButton_node
    ...Status_node
    ...FavouriteButton_node
    ...DownloadButton_node
    ...ShareButton_node
    ...EditOption_node
    ...RenameOption_node
    ...MoveOption_node
    ...DeleteNodeOption_node
    ...PinOption_node
    ...DuplicateOption_node
    ...AnnounceOption_node
    ...CreateShortcutOption_node
    ...AccessOption_node
    ...ManageVaultFieldsOption_node
    ...RequestSignaturesOption_node
    ...ThumbnailOption_node
    ...MarkAsOption_node
  }
`;

interface ItemMenuBeforeFragmentProps extends Omit<ItemMenuProps, 'node'> {
  node: ItemMenu_node$key;
}

export const ItemMenu = (props: ItemMenuBeforeFragmentProps) => {
  return (
    <ErrorBoundary fallback={<ItemMenuError />}>
      <Suspense fallback={<SkeletonText noOfLines={1} />}>
        <ItemMenuFragmentLoader {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

const ItemMenuFragmentLoader = ({
  node: nodeRef,
  ...props
}: ItemMenuBeforeFragmentProps) => {
  const node = useFragment(nodeFragment, nodeRef);
  return <ItemMenuComponent node={node} {...props} />;
};
